import BaseApi from './base';

class VehicleDevice extends BaseApi {
    endpoint = 'vehicle-devices';
}

export default new VehicleDevice();



// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/vehicle-device.js